const OFFICIAL_STORE_HOSTS = new Set([
  "chromewebstore.google.com",
  "chrome.google.com",
]);

export function parseChromeWebStoreUrl(
  value: string | undefined,
): string | null {
  if (!value) return null;
  try {
    const url = new URL(value);
    return url.protocol === "https:" &&
      OFFICIAL_STORE_HOSTS.has(url.hostname) &&
      url.pathname.includes("/detail/")
      ? url.href
      : null;
  } catch {
    return null;
  }
}

export const CHROME_WEB_STORE_URL = parseChromeWebStoreUrl(
  import.meta.env.VITE_CHROME_WEB_STORE_URL,
);

export const PRIVACY_POLICY_URL = "https://tokin-privacy.pages.dev";
